/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  Slide,
} from "@mui/material";
import { TransitionProps } from "notistack";
import React from "react";
import { DialogProps } from "./types";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export interface ConfirmDialogPayload {
  msg: React.ReactNode;
  title?: React.ReactNode;
  okText?: React.ReactNode;
  cancelText?: React.ReactNode;
  severity?: "error" | "info" | "success" | "warning";
}

export type ConfirmDialogProps = DialogProps<ConfirmDialogPayload, boolean>;

const ConfirmDialog = ({ open, payload, onClose }: ConfirmDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={() => onClose(false)}
      slots={{
        transition: Transition,
      }}
    >
      <DialogTitle sx={{ borderBottom: 2, mb: 2, borderColor: "divider" }}>
        {payload.title ?? "Confirm"}
      </DialogTitle>
      <DialogContent>{payload.msg}</DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)}>
          {payload.cancelText ?? "Cancel"}
        </Button>
        <Button
          color={payload.severity}
          variant="contained"
          onClick={() => onClose(true)}
        >
          {payload.okText ?? "OK"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default ConfirmDialog;
